import { FieldState, FormState } from 'formstate';
import { observable, computed } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { RouteComponentProps } from 'react-router';

import { LoginStore } from '../../stores/login.store';
import { lazyInject } from '../../ioc';
import { RouterStore } from 'src/core/stores/router.store';
import { BusyFormState } from 'src/util/busy-form';
import { emailValidator } from 'src/util/validators';

import { SignUpWelcome } from './desktop/sign-up-welcome';

interface RouteParams {
    token: string;
}

export class SignUpWelcomeFormState extends BusyFormState {
    @lazyInject(LoginStore) private loginStore!: LoginStore;
    @lazyInject(RouterStore) private router!: RouterStore;

    email = new FieldState('').validators(emailValidator);

    @observable errorMessage: string | undefined;
    @computed get firstName() {
        return this.loginStore.pwFormFirstName;
    }

    form = new FormState({
        email: this.email,
        isBusy: this.isBusy,
    }).validators(() => !this.token && 'invalid');

    private token: string | undefined;

    constructor(token: string) {
        super();

        this.form.validate();

        this.withBusy(this.loginStore.checkToken(token)).then(
            (email) => {
                this.email.onChange(email);
                this.token = token;
                this.form.validate();
            },
            (err) => (this.errorMessage = err)
        );
    }

    clearError = () => {
        this.errorMessage = undefined;
    };

    handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        this.loginStore.pwFormEmail = this.email.$;
        this.router.history.push(`/login/sign-up/${this.token}`);
    };
}

@observer
export class SignUpWelcomeContainer extends React.Component<RouteComponentProps<RouteParams>> {
    data: SignUpWelcomeFormState;

    constructor(props: RouteComponentProps<RouteParams>) {
        super(props);
        this.data = new SignUpWelcomeFormState(props.match.params.token);
    }

    render() {
        return <SignUpWelcome container={this} />;
    }
}
